import * as types from '../actions/authTypes';

const initialState = {
  registrationId: null,
  isAuthenticated: false,
  error: null,
};

export default function authReducer(state = initialState, action) {
  switch (action.type) {
    case types.REGISTER_SUCCESS:
      return {
        ...state,
        registrationId: action.payload.id,
        error: null,
      };
    case types.REGISTER_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    case types.LOGIN_SUCCESS:
      return {
        ...state,
        isAuthenticated: true,
        error: null,
      };
    case types.LOGIN_FAILURE:
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
}
